module.exports = require('./components/ktoquestioncount');
